import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Button } from '@mui/material'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { Company } from 'types/orga'
import RouteContainer from 'src/components/App/RouteContainer'

const CompanyList = React.lazy(() => loadComponent('orga', 'CompanyList'))

const StyledButton = styled(Button)`
    float: right;
`
const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function CompanyIndexRoute() {
    const navigate = useNavigate()

    const canCreate = usePermission('orga.company.create', {})
    const canDelete = usePermission('orga.company.delete', {})

    const onSelect = useCallback(
        (company: Company) => {
            navigate(company._id)
        },
        [navigate],
    )

    const onCreate = useCallback(() => {
        navigate('/companies/new')
    }, [navigate])

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Firmen</StyledHeadingText>
                {canCreate && (
                    <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                        neu
                    </StyledButton>
                )}
            </StyledHeaderContainer>
            <CompanyList onSelect={onSelect} onCreate={onCreate} canDelete={canDelete} />
        </RouteContainer>
    )
}
